<template>
  <div class="empty-content">
    <img src="@/assets/images/mountain.svg" alt="empty" />
    <div>
      <slot>
        <div class="m-t-24 grey-3">{{ label }}</div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyContent",
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    label() {
      return this.loading ? `${this.$t("loading")}...` : this.$t("no_data");
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-content {
  width: 100%;
  text-align: center;
  img {
    max-width: 100%;
  }
}
</style>
